import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Http, Headers } from '@angular/http';
import {Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseURL: String = environment.apiBaseUrl;
  headers: Headers;
  constructor(
      private http: Http,
  ) {
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
  }
  loginEmailUser(data: any) {
    console.log(data);
    return this.http.post(this.baseURL + '' + 'newLogin/', JSON.stringify(data), { headers: this.headers })
        .pipe(map(res => res.json()));
  }
}
